import { ServerFetch } from '../main-model'

export default class ReceiptDiscountListModel extends ServerFetch {
    getReceiptDiscountListBy = (data) => this.authFetch({
        url: 'receipt-discount-list/getReceiptDiscountListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}